import type React from "react";
import Styles from "./PasswordVisibilityToggle.module.scss";

interface PasswordVisibilityToggleProps {
	showPassword: boolean;
	onToggle: () => void;
}

export const PasswordVisibilityToggle: React.FC<PasswordVisibilityToggleProps> = ({ showPassword, onToggle }) => {
	return (
		<button type="button" className={Styles.eyeIcon} onClick={onToggle}>
			{showPassword ? <img src="/eye-open.png" alt="hide password" /> : <img src="/eye-closed.png" alt="show password" />}
		</button>
	);
};
